<template>
  <el-dialog title="店铺" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <div class="search-container mb-10">
      <el-input v-model="searchForm.shopName" placeholder="输入店铺名称" style="width: 300px" clearable></el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px">查询</el-button>
    </div>

    <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column prop="shopId" label="店铺ID" align="center"></el-table-column>
      <el-table-column prop="shopName" label="店铺名称" align="center"></el-table-column>
      <el-table-column prop="sendAddress" label="店铺地址" align="center"></el-table-column>
    </el-table>

    <el-pagination class="mt-10" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getNoRoleShops, saveRoleShop } from '@/api/frame/roleShopApi'

export default {
  name: 'AddRoleShop',
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        shopName: ''
      },
      tableData: [],
      selectedShops: [],
      formData: {
        roleId: '',
        shops: []
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.formData.roleId = params.roleId
      this.dialogVisible = true
      this.loadShops()
    },
    async loadShops() {
      try {
        const params = {
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          name: this.searchForm.shopName,
          roleId: this.formData.roleId
        }
        const res = await getNoRoleShops(params)
        this.tableData = res.data || []
        this.pagination.total = res.total || 0
      } catch (error) {
        console.error('获取店铺列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadShops()
    },
    handleSelectionChange(val) {
      this.selectedShops = val
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadShops()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadShops()
    },
    async handleSubmit() {
      if (this.selectedShops.length === 0) {
        this.$message.warning('请选择店铺')
        return
      }

      try {
        const params = {
          roleId: this.formData.roleId,
          communitys: this.selectedShops.map(item => ({
            communityId: item.shopId,
            communityName: item.shopName
          }))
        }
        const res = await saveRoleShop(params)
        if (res.code === 0) {
          this.$message.success('关联成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('关联店铺失败:', error)
        this.$message.error('关联店铺失败')
      }
    },
    handleClose() {
      this.searchForm.shopName = ''
      this.selectedShops = []
      this.pagination.currentPage = 1
    }
  }
}
</script>

<style scoped>
.search-container {
  display: flex;
  align-items: center;
}

.mb-10 {
  margin-bottom: 10px;
}

.mt-10 {
  margin-top: 10px;
}
</style>